import React from "react"

interface FormFieldGuideProps {
  onClick: () => void
}

/**
 * Button to open guide modal for a form field
 */
const FormFieldGuide: React.FC<FormFieldGuideProps> = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="text-md text-blue-400 hover:text-blue-300 underline focus:outline-none ml-auto"
  >
    Show Guide
  </button>
)

export default FormFieldGuide
